var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 256C575.999 273.602 561.736 288 544 288H511.994V480C511.994 497.672 497.666 512 479.994 512H384.004C366.33 512 352.004 497.672 352.004 480V367.994C352.004 359.158 344.842 351.994 336.006 351.994H240.012C231.176 351.994 224.012 359.158 224.012 367.994V480C224.012 497.672 209.686 512 192.012 512H96.023C78.35 512 64.023 497.672 64.023 480V288H32C14.222 288 0.001 273.557 0 256C0 246.948 3.842 238.104 10.922 231.906L266.922 7.922C273.885 1.824 281.857 0 288 0C295.523 0 303.047 2.641 309.078 7.922L565.078 231.906C572.158 238.104 576 246.948 576 256Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e61d2638ff6ff46e086b348a167b007a.svg";
export { ForwardRef as ReactComponent };